import { ISummaryTableDataNode } from 'components/common/SummaryTable/SummaryTable.properties';

const schema: ISummaryTableDataNode[] = [
    {
        objectName: 'PurchaseOrderSummary',
        isLoading: 'purchaseOrdersLoading',
        title: '',
        componentName: 'UpdateStatus',
        paperElevation: 0,
        unsetBackground: true,
    },
    {
        objectName: 'PurchaseOrderSummary',
        isLoading: 'purchaseOrdersLoading',
        title: 'Purchase order details',
        children: [
            {
                label: 'Purchase Order',
                fieldNames: ['PurchaseOrder'],
                valueRenderer: {
                    hyperLink: {
                        link: false,
                        menu: true
                    },
                    api: {
                        api: '/purchaseOrderEnquiry/lookup/action',
                        name: 'PurchaseOrder',
                        params: {
                            queryFields: {
                                PurchaseOrder: 'PurchaseOrder'
                            }
                        }
                    }
                }
            },
            {
                label: 'Supplier',
                fieldNames: [
                    'SupplierDisplay',
                    'SupplierDisplayLabel',
                    'SupplierCityState'
                ],
            },
            {
                label: 'Warehouse',
                fieldNames: [
                    'Warehouse',
                    'WarehouseLabel'
                ],
            },
            {
                label: 'Order Category',
                fieldNames: [
                    'PurchaseOrderCategory',
                    'PurchaseOrderCategoryDescription'
                ],
            },
            {
                label: 'Order Type',
                fieldNames: [
                    'OrderType',
                    'OrderTypeDescription',
                ],
            },
            {
                label: 'Transmit Method',
                fieldNames: [
                    'TransmitMethod',
                ],
            },

        ]
    },
    {
        objectName: 'PurchaseOrderSummary',
        isLoading: 'purchaseOrdersLoading',
        children: [
            {
                label: 'Created',
                fieldNames: [
                    'CreatedDate',
                ],
            },
            {
                label: 'Ship Date',
                fieldNames: [
                    'ShipDate',
                ],
            },
            {
                label: 'Earliest Due',
                fieldNames: [
                    'DueDate',
                ],
            },
            {
                label: 'Last Transmit',
                fieldNames: [
                    'TransmitDate',
                ],
            },
        ]
    },
    {
        objectName: 'PurchaseOrderSummary',
        isLoading: 'purchaseOrdersLoading',
        title: 'Totals',
        children: [
            {
                label: 'Currency',
                fieldNames: [
                    'Currency',
                ],
            },
            {
                label: 'Outstanding',
                fieldNames: [
                    'OutstandingDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Order Total',
                fieldNames: [
                    'OrderTotalDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Tax Included Prices',
                fieldNames: [
                    'TaxIncludedDisplay',
                ],
            },
        ]
    },
];

export default schema;
